// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2NyNf","header":"PatientQuestionnaire_header__1bb71","info":"PatientQuestionnaire_info__1Yrzu"};